import { CardEvent, CardSubeventInfo, CardSubeventsData } from "features/shared/OpenedCardEvents/types";
import { TransformedEventModel } from "entities/RailSearchCard";
import { TO_BE_NOMINATED } from "shared/constants/common.constants";
import { findLastIndex } from "shared/lib/common.lib";
import { Nullable } from "shared/lib/typeCheck.lib";
import { formatCardDate } from "shared/utils/dateTime.utils";

export const createEvents = (eventsList: Nullable<TransformedEventModel[]>): CardEvent[] => {
  if (!eventsList) return [];

  let createdEvents = eventsList.map<CardEvent>(({ location, events }) => {
    const transformedSubevents = events.reduce<CardSubeventsData>(
      (acc, event) => {
        const isActual = !!event.datetime.actual;
        const isFutureSubevent = !isActual;
        const date = event.datetime.actual ?? event.datetime.estimated;
        acc.dateList.push({
          value: date ? formatCardDate(date, { withTime: true, format: "24h" }) : TO_BE_NOMINATED,
          isFutureSubevent,
        });
        acc.descriptionList.push({ value: event.description ?? "", isFutureSubevent });

        return acc;
      },
      {
        dateList: [],
        descriptionList: [],
      }
    );

    return { location: location ?? TO_BE_NOMINATED, subEvents: transformedSubevents, isFutureEvent: false };
  });

  createdEvents = createdEvents.reduce<CardEvent[]>((acc, currentEvent, index) => {
    acc[index].isFutureEvent =
      currentEvent.subEvents.descriptionList.every((subEventData) => subEventData.isFutureSubevent) ||
      currentEvent.subEvents.dateList.every((subEventData) => subEventData.isFutureSubevent);
    return acc;
  }, createdEvents);

  const lastPresentEventIndex = findLastIndex(createdEvents, (ev) => !ev.isFutureEvent);

  if (lastPresentEventIndex !== -1) {
    const lastPresentEvent = createdEvents[lastPresentEventIndex];
    if (lastPresentEvent.subEvents.dateList.length) {
      lastPresentEvent.subEvents.dateList = getSubeventInfoWithTotalPresent(lastPresentEvent.subEvents.dateList);
    }
    if (lastPresentEvent.subEvents.descriptionList.length) {
      lastPresentEvent.subEvents.descriptionList = getSubeventInfoWithTotalPresent(
        lastPresentEvent.subEvents.descriptionList
      );
    }
  }

  return createdEvents;
};

const getSubeventInfoWithTotalPresent = (cardSubeventInfoList: CardSubeventInfo[]): CardSubeventInfo[] => {
  const copy = cardSubeventInfoList.slice();
  const lastPresentSubeventIndex = findLastIndex(copy, (item) => !item.isFutureSubevent);
  if (lastPresentSubeventIndex !== -1) {
    copy[lastPresentSubeventIndex].isTotalLastPresentSubevent = true;
  }
  return copy;
};
